/**
 * QuantitySelector — stepper input for quantity
 */
import { useTranslation } from "react-i18next";

interface QuantitySelectorProps {
  value: number;
  onChange: (quantity: number) => void;
}

export function QuantitySelector({
  value,
  onChange,
}: Readonly<QuantitySelectorProps>) {
  const { t } = useTranslation();

  return (
    <div>
      <label className="sr-only">{t("SingleProductPage.quantity")}</label>
      <div className="flex h-12 w-32 items-center rounded-full bg-white ring-1 ring-black/[0.08]">
        <button
          type="button"
          onClick={() => onChange(Math.max(1, value - 1))}
          className="flex size-12 shrink-0 items-center justify-center rounded-full text-medium hover:bg-background-6"
          aria-label={t("SingleProductPage.decreaseQuantity")}
        >
          -
        </button>
        <input
          type="number"
          min="1"
          value={value}
          onChange={e =>
            onChange(Math.max(1, Number.parseInt(e.target.value) || 1))
          }
          className="w-full min-w-0 bg-transparent text-center font-semibold tabular-nums [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
          aria-label={t("SingleProductPage.quantity")}
        />
        <button
          type="button"
          onClick={() => onChange(value + 1)}
          className="flex size-12 shrink-0 items-center justify-center rounded-full text-medium hover:bg-background-6"
          aria-label={t("SingleProductPage.increaseQuantity")}
        >
          +
        </button>
      </div>
    </div>
  );
}
